import { createContext, useContext } from 'react'
import { ILessonContext, ILessonContextProps } from './types'

const LessonContext = createContext<ILessonContext | null>(null)

export function LessonContextProvider(props: ILessonContextProps) {
  return (
    <LessonContext.Provider
      value={{ swrLesson: props.swrLesson, swrMenuContent: props.swrMenuContent }}
    >
      {props.children}
    </LessonContext.Provider>
  )
}

export const useLessonContext = (): ILessonContext => {
  const context = useContext(LessonContext)

  if (context === null) {
    throw new Error('useLessonContext must be used within LessonContextProvider')
  }

  return context
}
